module.exports = __webpack_public_path__ + "assets/img/03.59fb3e58.jpg";